import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/core/auth/AuthContext';
import { ThemeProvider } from '@/core/layout/ThemeContext';
import { ErrorBoundary } from '@/core/error/ErrorBoundary';
import { CredoraToastContainer } from '@/core/error/CredoraToastContainer';
import { PlanLimitProvider } from '@/features/admin/PlanLimitProvider';
import { queryClient } from './query-client';
import { AppRoutes } from './routes';

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ThemeProvider>
            <BrowserRouter>
              <PlanLimitProvider>
                <AppRoutes />
                <CredoraToastContainer />
              </PlanLimitProvider>
            </BrowserRouter>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
